<template>
  <div class="app-container">

  <!-- <div style="border: 1px solid red;"> -->
     <el-row type="flex" justify="center">
        <el-col  :xs="24" :sm="22" :md="18" :lg="12" :xl="8">
         <el-form ref="form" :model="form" :rules="rules" label-width="80px" style=" box-shadow: 0px 0px 10px #999;  border: 1px solid #ddd; padding: 70px 40px; margin-top: 30px; background: #fff;">

          <div style="font-size: 24px;font-weight: bold; text-align: center;width: 100%;margin-top: 0px; margin-bottom: 50px; ">供应商合作申请</div>

           <el-row>
              <!-- <el-col :span="12">
               <el-form-item label="类型" prop="type">
                 <el-select v-model="form.type" placeholder="请选择类型">
                   <el-option
                     v-for="dict in dict.type.b_supplier_type"
                     :key="dict.value"
                     :label="dict.label"
                     :value="dict.value"
                   ></el-option>
                 </el-select>
               </el-form-item>
             </el-col> -->
             <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
               <el-form-item label="产品名称" prop="productName">
                 <el-input v-model="form.productName" placeholder="请输入产品名称" maxlength="64" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row>

           <el-row>
             <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
               <el-form-item label="公司名称" prop="companyName">
                 <el-input v-model="form.companyName" placeholder="请输入公司名称" maxlength="128" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row>
           <el-row>
             <el-col :span="24">
               <el-form-item label="公司地址" prop="companyAddr">
                 <el-input v-model="form.companyAddr" placeholder="请输入公司地址" maxlength="255" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row>

           <el-row>
             <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
              <el-form-item label="联系人" prop="contacts">
                <el-input v-model="form.contacts" placeholder="请输入联系人" maxlength="20" show-word-limit/>
              </el-form-item>
             </el-col>
           </el-row>

           <el-row>
             <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
               <el-form-item label="联系电话" prop="contactPhone">
                 <el-input v-model="form.contactPhone" placeholder="请输入联系电话" maxlength="20" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row>

           <el-row>
             <el-col :span="24">
               <el-form-item label="优势说明" prop="advantageExp">
                 <el-input v-model="form.advantageExp"   type="textarea" :rows="3" placeholder="请输入优势说明" maxlength="255" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row>

           <!-- <el-row>
             <el-col :span="12">
               <el-form-item label="联系邮箱" prop="contactEmail">
                 <el-input v-model="form.contactEmail" placeholder="请输入联系邮箱" maxlength="64" show-word-limit/>
               </el-form-item>
             </el-col>
           </el-row> -->
           <el-row>
             <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
               <el-form-item label="验证码" prop="code">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <el-input v-model="form.code" placeholder="验证码" style="width: 58%"/>
                  <img :src="codeUrl" @click="getCode" class="code-img" style="margin-left: 10px;" />
                </div>
               </el-form-item>
             </el-col>
           </el-row>


           <el-row>
             <el-form-item style="width: 100%">
               <el-button
                 :loading="loading"
                 size="medium"
                 type="primary"
                 style="width: 100px;"
                 @click.native.prevent="submitForm"
               >
                 <span v-if="!loading">提交</span>
                 <span v-else>提交中...</span>
               </el-button>
             </el-form-item>
           </el-row>
         </el-form>
       </el-col>
    </el-row>
  <!-- </div> -->


  </div>
</template>
<script>
import check from "./check.vue";
// import { getFvSupplierMgr, applySupplier} from "@/api/fv/FvSupplierMgr";
// import ImgUpload from "@/components/ImageUpload/ossImageUpload.vue";
import {validExpr} from "./util/validate.js";
// import { getCodeImg } from "@/api/login";
export default {
  name: "FvSupplierMgr",
  // components: {
  //   ImgUpload
  // },
  // dicts: ['b_supplier_type', 'b_supplier_status'],
  data() {
    return {
      codeUrl: "",
      // 遮罩层
      loading: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        type: [
          { required: true, message: "类型不能为空", trigger: "change" }
        ],
        productName: [
          { required: true, message: "产品名称不能为空", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "blur" }
        ],
        contactPhone: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
          {
            pattern: validExpr.phone.expr,
            message: validExpr.phone.msg.zh
          }
        ],
        status: [
          { required: true, message: "状态不能为空", trigger: "change" }
        ],
        deliveryCycle: [
          {
            pattern: validExpr.integer.expr,
            message: validExpr.integer.msg.zh
          }
        ],
        miniMoney: [
          {
            pattern: validExpr.oneDecimal.expr,
            message: validExpr.oneDecimal.msg.zh
          }
        ],
        // miniNum: [
        //   {
        //     pattern: validExpr.oneDecimal.expr,
        //     message: validExpr.oneDecimal.msg.zh
        //   }
        // ],
        contactEmail: [
          {
            pattern: validExpr.email.expr,
            message: validExpr.email.msg.zh
          }
        ],
      }
    };
  },
  components:{
    check
  },
  beforeCreate(){
      document.title = "申请入驻"
  },
  created() {
    
    // this.getList();
    this.getCode();
    this.reset();
   
  },
  methods: {
    getCode() {
      let that = this;
      this.form.uuid = '';
      this.form.code = '';
      // getCodeImg().then((res) => {
      //     this.codeUrl = "data:image/gif;base64," + res.img;
      //     this.form.uuid = res.uuid;
      // });/captchaImage

      this.$axios({
        method: 'get',
        url: "http://yczw.nongzhengqimin.com:8082/prod-api/captchaImage",
        // data:this.form
      }).then(function (res) {
        console.log(res)
        if(res.data.code == 200){
          that.codeUrl = "data:image/gif;base64," + res.data.img;
          that.form.uuid = res.data.uuid;           
        }

        // that.loading = false;
        // that.$refs.checkCode.refreshCaptcha();
      })
    },
    /** 查询供应商管理列表 */
    // getList() {
    //   this.loading = true;
    //   listFvSupplierMgr(this.queryParams).then(response => {
    //     this.FvSupplierMgrList = response.rows;
    //     this.total = response.total;
    //     this.loading = false;
    //   });
    // },
    // 取消按钮
    // cancel() {
    //   this.open = false;
    //   this.reset();
    // },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        type: null,
        productName: null,
        companyName: null,
        companyAddr: null,
        contacts: null,
        contactPhone: null,
        contactEmail: null,
        status: '0',
        advantageExp: null,
        uuid:null,
        code:null,
      };
      // this.resetForm("form");
    },

    /** 修改按钮操作 */
    // handleUpdate(row) {
    //   this.reset();
    //   const id = row.id || this.ids
    //   getFvSupplierMgr(id).then(response => {
    //     this.form = response.data;
    //     this.open = true;
    //     this.title = "修改供应商";
    //   });
    // },
    /** 提交按钮 */
    submitForm() {
      let that = this;
      this.$refs["form"].validate(valid => {
        if (valid) {
            //验证验证码
            // let checkResult = that.$refs.checkCode.validateCaptcha(this.form.code);
            // if(checkResult==false){
            //     this.$message({
            //         message: '验证码错误',
            //         type: 'error'
            //     })
            //     return;
            // }
            that.loading = true;
            this.$axios({
              method: 'post',
              url: "http://yczw.nongzhengqimin.com:8082/stage-api/fv/FvSupplierMgr/apply",
              data:this.form
            }).then(function (res) {
              console.log(res.data.code)
              if(res.data.code == 200){
                 that.$message.success("提交成功！")
                 setTimeout(() => {
                   window.location.reload(); 
                 }, 1000);
              }else{
                that.$message.error("提交失败 ！")
              }
              that.loading = false;
              // that.getCode();
            })
            
            // applySupplier(this.form).then(response => {
            //   this.$modal.msgSuccess("提交成功");
            //   this.loading = false;
            //   // this.getCode();
            // }).catch((e) => {
            //   console.error(e)
            //   this.loading = false;
            //   // this.getCode();
            // });
        }
      });
    },

  }
};
</script>
<style scoped>
  .app-container {
    min-height: 100vh;
    border: 1px solid #Ffff;
    background: #efefef;
    /* display: flex;
    justify-content: center; */
  }
  ::v-deep .code {
    width: 30%;
    height: 36px;
    /* float: right; */
    display: inline-block;
    margin-left: 10px;
    img {
      cursor: pointer;
      vertical-align: bottom;
    }
  }
  .code-img {
    height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apply/apply.vue